'use client';

import { memo, useState } from 'react';

import { SelectableAccordion } from './Accordions';

import type { AccordionProps } from '@mui/material';
import type { FC, ReactNode, SyntheticEvent } from 'react';

export interface SelectableAccordionsProps<
  T extends Omit<AccordionProps, 'children'> & {
    id: string;
    summary: string;
    details?: ReactNode;
  } = Omit<AccordionProps, 'children'> & {
    id: string;
    summary: string;
    details?: ReactNode;
  },
> {
  accordions: T[];
  accordion?: typeof SelectableAccordion;
}

export const SelectableAccordions: FC<SelectableAccordionsProps> = memo(
  ({ accordions, accordion: RenderAccordion = SelectableAccordion }) => {
    const [selectedAccordion, setSelectedAccordion] = useState<string>( '' );
    const handleChangeExpanded = (id: string) => (_: SyntheticEvent, isExpanded: boolean): void => {
      setSelectedAccordion( isExpanded ? id : '' );
    };

    return (
      <>
        {accordions.map((accordion) => (
          <RenderAccordion
            key={accordion.id}
            expanded={selectedAccordion === accordion.id}
            onChange={handleChangeExpanded( accordion.id )}
            {...accordion}
          />
        ))}
      </>
    );

    /**
   @todo: fixing the Accordions animation. Probably an issue with the rendering order. RenderAccordion knows about its
   "expanded" status before the HigherOrderFunction returns it while mapping of the Accordions Component occurs
   */
    // return (
    //   <Accordions
    //     accordions={accordions}
    //     accordion={ ({ id, ...props }) => (
    //       <RenderAccordion
    //         expanded={selectedAccordion === id}
    //         onChange={handleChangeExpanded(id)}
    //         {...props}
    //       />
    //     ) }
    //   />
    // );
  }
);

SelectableAccordions.displayName = 'SelectableAccordions';
